module.exports = __webpack_public_path__ + "media/app_search/ResultSettings/assets/result-settings-illustration-ece3352670753e528b30985827626711.svg";